import { ReactNode } from 'react';
import { Icon, UtilityButton } from '@kinesis/bungle';

// As suit's export button: a download icon that turns to a spinner, and the
// button disabled, while its link is being generated.
const ExportButton = (props: ExportButtonProps) => {
  const { children, downloading = false, onClick } = props;
  return (
    <UtilityButton
      disabled={downloading}
      icon={
        downloading ? (
          <Icon animation='rotate' magnitude='medium' type='spinner' />
        ) : (
          'download'
        )
      }
      onClick={onClick}
    >
      {children}
    </UtilityButton>
  );
};

export type ExportButtonProps = {
  children?: ReactNode;
  downloading?: boolean;
  onClick?: () => void;
};

export { ExportButton };
